import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComputerLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/device/computer_line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M19 3C20.1046 3 21 3.89543 21 5V16C21 17.1046 20.1046 18 19 18H15V19H16C16.5523 19 17 19.4477 17 20C17 20.5523 16.5523 21 16 21H8C7.44772 21 7 20.5523 7 20C7 19.4477 7.44772 19 8 19H9V18H5C3.89543 18 3 17.1046 3 16V5C3 3.89543 3.89543 3 5 3H19ZM13 18H11V19H13V18ZM19 5H5V16H19V5Z"
		})
	})
});
export default SvgComputerLine;
